<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="text-header">Diagnosis</h5>
                <b-row class="mt-5">
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <div>
                                    <h5 class="text-title">Primer</h5>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <template v-if="dataRM.kode_diagnosa_primary">
                                <template
                                    v-if="dataRM.kode_diagnosa_primary.id == '34335' || dataRM.kode_diagnosa_primary.kode == 'IZDOTHER'">
                                    <b-col md="12">
                                        <p v-html="dataRM.kode_diagnosa_primary.description"></p>
                                    </b-col>
                                </template>
                                <template v-else>
                                    <b-col md="12" class="text-subtitle">
                                        {{ `${dataRM.kode_diagnosa_primary.kode} - ${dataRM.kode_diagnosa_primary.description}` }}
                                    </b-col>
                                </template>
                            </template>
                            <template v-else>
                                <b-col md="12">-</b-col>
                            </template>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <div>
                                    <h5 class="text-title">Sekunder</h5>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <template v-if="dataRM.kode_diagnosa.length > 0">
                                <b-col md="12">
                                    <b-row v-for="(items, index) in dataRM.kode_diagnosa" :key="index">
                                        <b-col md="12" class="text-subtitle mb-2">
                                            {{ `${items.kode} - ${items.description}` }}
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col md="12">-</b-col>
                            </template>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-5">
                    <b-col md="12" :style="`width: ${contentWidth}px;`">
                        <div class="text-title">Catatan</div>
                        <div v-html="this.dataRM.diagnosa.notes || '-'"></div>
                        <template v-if="checkValueData(dataRM.diagnosa.draw_path)">
                            <img :src="dataRM.diagnosa.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <b-row>
                    <b-col md="6" v-if="satusehatAuthValid">
                        <h5 class="text-header">Kondisi</h5>
                        <template v-if="dataRM.condition_ids && dataRM.condition_ids.length > 0">
                            <b-row v-for="(con, idx) in dataRM.condition_ids" :key="idx">
                                <b-col md="12" class="text-subtitle mb-2">
                                    {{ con.name }}
                                </b-col>
                            </b-row>
                        </template>
                        <template v-else>-</template>
                    </b-col>
                    <b-col cols="6">
                        <h5 class="text-header">Prognosa</h5>
                        <div v-html="prognosa || '-'"></div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import rekamMedisMixin from '../mixins';
    import { mapGetters, mapState } from 'vuex';

    export default {
        name: 'Assessment',
        mixins: [rekamMedisMixin],
        props: ['dataRM', 'pcareVersion'],
        data() {
            return {
                prognosa: null,
                optPrognosa: [],
                contentWidth: 110,
            }
        },
        computed: {
            ...mapState(['sidebar']),
            ...mapGetters('sidebar', ['collapsed']),
            ...mapGetters(['getKlinikId', 'satusehatAuthValid']),
        },
        mounted() {
            this.resizeWidth(window.innerWidth, this.collapsed);
            this.buildData();
        },
        watch: {
            dataRM() {
                this.buildData()
            },
            collapsed() {
                this.resizeWidth(window.innerWidth, this.collapsed);
            },
        },
        methods: {
            resizeWidth(w, collapsed = false) {
                let zoom = w / 19.2;

                let x = 1.415;
                if (collapsed) {
                    if (zoom < 100) x = 1.325;
                    else x = 1.2;
                } else if (zoom < 100) x = 1.7;

                this.contentWidth = w / x;
            },
            buildData() {
                if (this.dataRM) {
                    this.setPrognosa();
                }
            },
            async setPrognosa() {
                this.prognosa = this.dataRM.bpjs_health_data ? this.dataRM.bpjs_health_data.kd_prognosa : null;
                if (this.checkValueData(this.prognosa)) {
                    if (this.optPrognosa.length < 1) this.optPrognosa = await this.fetchPrognosa(this.getKlinikId);
                    const data = this.optPrognosa.find(v => v.value == this.prognosa);
                    if (data) this.prognosa = data.label;
                }
            },
        }
    }
</script>

<style>
    .mb-header {
        margin-bottom: -15px;
    }
</style>